import { useEffect } from "react";
import { meta } from "./meta";

export function useAttribution() {
  useEffect(() => {
    if (/^\/(admin|login)(\/|$)/i.test(window.location.pathname)) return undefined;
    if (window.location.pathname === "/client-portal" && new URLSearchParams(window.location.search).get("preview") === "1") return undefined;
    const boot = window.__mihAttribution;
    if (boot?.flush) boot.flush();
    window.mihEvents = {
      track(eventName, metadata = {}) {
        const ids = boot?.getIds?.() || {};
        fetch("/api/funnel_event.php", {
          method: "POST", headers: { "Content-Type": "application/json" }, keepalive: true,
          body: JSON.stringify({ ...ids, event_name: eventName, metadata }),
        }).catch(() => {});
      },
    };
    window.mihMeta = meta;
    meta.init().then(() => { meta.trackPageView(); meta.trackViewContent(); setTimeout(() => boot?.syncMetaCookies?.(), 1500); });
    window.mihEvents.track("landing_viewed", { landing_variant: boot?.getSnapshot?.()?.query_params?.landing_variant || "default" });
  }, []);
}
